<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-toolbar color="pink" dark>
          <v-toolbar-title>What's Next</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="loadTasks()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-list-item
              :key="item.title"
              ripple
              @click="actionOnTask(item.action, item.postID)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.text }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon ripple>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import config from '@/config'
  import PostAPI from '../Post/postApi'
  import userAPIs from '../User/userAPIs'
  import pairingAPIs from '../Pairing/pairingAPIs'
  import api from '@/api'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        items: []
      }
    },
    methods: {
      loadTasks() {
        // const status = [this.statusINVITED, this.statusINTERESTED, this.statusNOTINTERESTED, this.statusACCEPTED, this.statusNOTACCEPTED, this.statusINQUIRY];
        this.items = [
          // default task for Influencer to submit
          // to do - Only show if the influnecer have assigned campaign or eligible to submit
          {
            action: 'submitDraft',
            title: 'Submit Draft Post',
            text: 'Submit your draft post for the campaign.'
          }
        ]
        this.checkForApprovedPost()
        this.checkForProfileEdit()
        this.checkForNewComments()
        // this.getInvitedCampaign(this.influencerID, status.join(','));
      },
      actionOnTask(task, postID) {
        switch (task) {
          case 'updateProfile':
            this.$router.push({path: 'profile'});
            break;
          case 'submitDraft':
            this.$router.push({path: 'v2/submit-draft-post'});
            break;
          case 'viewApproved':
            this.$router.push({path: '/posts/approved'});
            break;
          case 'viewPost':
            this.$router.push({path: '/posts/pending-client', query: { action: 'view', id: postID }});
            break;
          case 'invitedCampaign':
            this.$router.push({path: '/campaigns/invited'})
        }
      },
      checkForApprovedPost() {
        let status = config.postStatus.APPROVE
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            if (posts.length > 0) {
              this.items.push({
                action: 'viewApproved',
                title: 'Get Ready to publish',
                text: `You have ${posts.length} scheduled post(s) to publish.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      checkForProfileEdit() {
        // Retrieve user profile
        userAPIs.getUser(this.currentUserID)
          .then(user => {
            if (!user.influencer.bankAccount ||
              !user.influencer.mailingAddress ||
              !user.influencer.bankName ||
              !user.influencer.fullName
            ) {
              this.items.push({
                action: 'updateProfile',
                title: 'Please Update Your Profile',
                text: `We found that you haven’t completed the required information.`
              })
            }
          })
          .catch(error => {
            // Request failed.
            console.log('error', error)
          })
      },
      checkForNewComments() {
        // check for new comments and add to Influencer tasks
        // To-Do check by notification type
        api
          .request('get', '/api/v1/notifications', true)
          .then(response => {
            if (response.status !== 200) {
              return;
            }
            response.data.forEach(element => {
              if (!element.readAt) {
                this.items.push({
                  action: 'viewPost',
                  title: element.title,
                  text: element.body,
                  type: element.type,
                  postID: element.postID
                })
              }
            });
          })
          .catch(() => {
            // Request failed.
          });
      },
      async getInvitedCampaign(influencerID, status) {
        try {
          const campaigns = await pairingAPIs.getInvitedCampaigns(influencerID, status);
          this.campaigns = Object.assign([], campaigns);
          if (campaigns.length > 0) {
            this.items.push({
              action: 'invitedCampaign',
              title: 'Your invited campaigns',
              text: `You have been invited for ${campaigns.length} campaign(s).`
            })
          }
        } catch (error) {
          console.log(error)
        }
      }
    },
    mounted() {
      this.loadTasks()
    },
    computed: {
      ...mapGetters('pairing', {
        pairingStatus: 'status'
      }),
      influencerID() {
        return this.$store.state.user.influencerID;
      },
      statusINVITED() {
        // return campaignConfigs.pairingStatus.INVITED;
        return this.pairingStatus.INVITED.value;
      },
      statusINTERESTED() {
        // return campaignConfigs.pairingStatus.ACCEPT;
        return this.pairingStatus.INTERESTED.value;
      },
      statusNOTINTERESTED() {
        // return campaignConfigs.pairingStatus.REJECT;
        return this.pairingStatus.NOT_INTERESTED.value;
      },
      statusACCEPTED() {
        // return campaignConfigs.pairingStatus.ACCEPT;
        return this.pairingStatus.ACCEPTED.value;
      },
      statusNOTACCEPTED() {
        // return campaignConfigs.pairingStatus.ACCEPT;
        return this.pairingStatus.NOT_ACCEPTED.value;
      },
      statusINQUIRY() {
        // return campaignConfigs.pairingStatus.ACCEPT;
        return this.pairingStatus.INQUIRY.value;
      },
      currentUserID: function () {
        return this.$store.state.user.id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InfluencerTasks.vue?771984c3